import request from "../../utils/wapRequest";
const BASE_URL = process.env.VUE_APP_WAP_API;

const BankResource = {
  confirm_order_booking_SCB(data) {
    return request({
      url: `${BASE_URL}/confirm_order_booking_SCB`,
      method: "POST",
      data
    });
  },
  confirm_order_booking_viettin(data) {
    return request({
      url: `${BASE_URL}/confirm_order_booking_viettin`,
      method: "POST",
      data
    });
  },
  confirm_booked_bank(data) {
    return request({
      url: `${BASE_URL}/confirm_booked_bank`,
      method: "POST",
      data
    });
  }
};
export { BankResource as default };
